<div class="overlay">
  <div class="loader-container">
    <div class="progress-title">
      Adding <span class="progress-title-bold">{{ deviceId }}</span> in the list
    </div>
    <div class="progress-text">{{ current }} / {{ max }}</div>

    <div class="progress-bar">
      <div class="progress-bar-fill" [style.width.%]="progressPercent"></div>
    </div>
  </div>
</div>
